import React, { type CSSProperties, type ReactElement, type ReactNode, useContext } from 'react';

import classnames from 'classnames';

import { ListContext } from './List';

import styles from './List.module.scss';

export interface ListItemProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    children?: ReactNode;
    style?: CSSProperties;
    /**
     * The extra content of list item. Shows content on the far right
     */
    extra?: ReactNode;
    /**
     * The actions content of list item. Shows content on the far right
     */
    actions?: React.ReactElement[];
    colStyle?: CSSProperties;
}

export const ListItem = ({
    className,
    children,
    extra,
    actions,
    colStyle,
    style,
    ...rest
}: ListItemProps): ReactElement => {
    const { showActionsDivider } = useContext(ListContext);

    return (
        <div
            className={classnames(styles.listItem, className)}
            style={{ ...style, ...colStyle }}
            data-testid="list-item"
            role="listitem"
            {...rest}
        >
            {children}
            {extra}
            {actions && (
                <div
                    className={classnames(styles.actions, {
                        [styles.withDivider]: showActionsDivider
                    })}
                >
                    {actions.map((action, index) => (
                        <React.Fragment key={`list-item-action-${action?.key}`}>
                            <div className={styles.action}>{action}</div>
                            {showActionsDivider && index < actions.length - 1 && (
                                <em className={styles.divider} data-testid="action-divider" />
                            )}
                        </React.Fragment>
                    ))}
                </div>
            )}
        </div>
    );
};
